<template>
    <el-dialog title="进度设置" :close-on-click-modal="false" :visible.sync="visible" width="500px">
        <el-row class="set_border">
            <el-col :span="8">
                <div class="majTitle1">专业</div>
            </el-col>
            <el-col :span="16">
                <!-- <div class="majTitle2"> {{ dataForm.majorName }}</div> -->
                <div class="majTitle3">
                    <el-select v-model="dataForm.majorNo" placeholder="请选择" class="sp-input1">
                        <el-option v-for="item in majorList" :key="item.displayValue" :label="item.displayName"
                            :value="item.displayValue">
                        </el-option>
                    </el-select>
                </div>
            </el-col>
        </el-row>
        <el-row class="set_border">
            <el-col :span="8">
                <div class="majTitle1">表格名称</div>
            </el-col>
            <el-col :span="16">
                <div class="majTitle3">
                    <el-input class="sp-input1" v-model="dataForm.itemName"></el-input>
                </div>
            </el-col>
        </el-row>
        <el-row class="set_border1">
            <el-col :span="8">
                <div class="majTitle1">名称（第一列）</div>
            </el-col>
            <el-col :span="16">
                <div class="majTitle3">
                    <el-input class="sp-input1" v-model="dataForm.titleName"></el-input>
                </div>
            </el-col>
        </el-row>
        <el-row style="margin-top: 20px;">
            <el-table ref="dataListTable" class="dataListTable" :data="dataForm.subList" header-align="center" border
                :cell-style="{ padding: '0px' }" header-cell-class-name="dataListTHeader" style="margin-bottom: 20px;">
                <el-table-column label="NO." prop="colSort" width="80" align="center">
                    <template slot-scope="scope">
                        <span v-if="!getDisabled(scope.$index)">{{ scope.row.colSort }}</span>
                        <el-input class="sp-input" v-if="getDisabled(scope.$index)"
                            v-model="scope.row.colSort"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="分项节点名称" prop="subProgressName" width="259" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="!getDisabled(scope.$index)">{{ scope.row.subProgressName }}</span>
                        <el-input class="sp-input" v-if="getDisabled(scope.$index)"
                            v-model="scope.row.subProgressName"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="" width="100" align="center">
                    <template slot-scope="scope">
                        <el-button v-preventReClick type="text" size="small" class="min_btn"
                            v-if="!updateFlg && !addFlg"
                            @click="updateSubProgressHandle(scope.$index, scope.row)">修改</el-button>
                        <el-button v-preventReClick type="text" size="small" class="min_btn"
                            v-if="!updateFlg && !addFlg" @click="deleteHandle(scope.$index)">删除</el-button>
                        <!--新增时按钮-->
                        <el-button v-preventReClick type="text" size="small" @click="saveHandle()"
                            v-if="getDisabled(scope.$index) && addFlg">保存</el-button>
                        <el-button v-preventReClick type="text" size="small" @click="cancelSaveHandle()"
                            v-if="getDisabled(scope.$index) && addFlg">取消</el-button>
                        <!--修改时按钮-->
                        <el-button v-preventReClick type="text" size="small" @click="updateHandle()"
                            v-if="getDisabled(scope.$index) && updateFlg">保存</el-button>
                        <el-button v-preventReClick type="text" size="small" @click="cancelUpdateHandle()"
                            v-if="getDisabled(scope.$index) && updateFlg">取消</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row style="margin-top: 10px;">
            <el-col :span="20">
                <el-button v-preventReClick class="btn" type="primary" size="small" :disabled="updateFlg || addFlg"
                    @click="addSubProgressHandle()"> + 添加分项节点</el-button>
            </el-col>
            <el-col :span="4">
                <el-button v-preventReClick class="btn" type="primary" size="small" :disabled="updateFlg || addFlg"
                    @click="dataFormSubmit()">保存</el-button>
            </el-col>
        </el-row>

        <el-row class="formBtnGroup">
        </el-row>
    </el-dialog>
</template>

<script>

import $common from "@/utils/common.js"
export default {
    data() {
        return {
            visible: false,
            inline: false,
            subjectTypeList: [],
            majorList: [],
            dataForm: {
                workNo: '',
                itemName: '',
                titleName: '',
                majorNo: '',
                majorName: '',
                infoList: [
                ]
            },
            updateIndex: '',
            updateFlg: false,
            addIndex: '',
            addFlg: false,
            dataRule: {
                // projectNo: [
                //     { required: true, message: "编号不能为空", trigger: "blur" }
                // ],
            },
            updateData: {
                colSort: 0,
                subProgressName: '',
            }
        }
    },
    computed: {
    },
    methods: {
        getMajorList() {
            this.$http({
                url: this.$store.state.httpUrl + "/common/getMajorByWorkNo/" + $common.getItem("workNo"),
                method: "get",
                params: {},
            }).then(({
                data
            }) => {
                if (data && data.resultCode === 200) {
                    this.majorList = data.body;
                }
            });
        },
        getDisabled(index) {
            if (this.addIndex === '' && this.updateIndex === '') {
                return false;
            } else if (this.addIndex === index && this.addIndex !== '') {
                return true;
            } else if (this.updateIndex === index && this.updateIndex !== '') {
                return true;
            } else {
                return false;
            }
        },
        init(progressNo, majorNo) {
            this.dataForm = {
                workNo: '',
                itemName: '',
                titleName: '',
                majorNo: '',
                majorName: '',
                subList: [
                ]
            }
            this.dataForm.majorNo = majorNo ? majorNo : "";
            this.dataForm.workNo = $common.getItem("workNo");
            this.dataForm.progressNo = progressNo ? progressNo : ""
            this.visible = true;
            this.updateIndex = ''
            this.updateFlg = false
            this.addFlg = false
            this.getMajorList()
            if (progressNo != '') {
                this.getInfo()
            }
            // this.$nextTick(() => {
            //     this.$refs["dataForm"].resetFields()
            // })
        },
        getInfo() {
            this.$http({
                url: this.$store.state.httpUrl + "/business/projectprogress/info/" + this.dataForm.progressNo,
                method: "get",
                params: {},
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.dataForm = data.body
                }
            });
        },
        updateSubProgressHandle(index, subProgress) {
            this.updateFlg = true;
            this.updateIndex = index;
            this.updateData = {
                colSort: subProgress.colSort,
                subProgressName: subProgress.subProgressName,
            }
        },
        saveHandle() {
            this.addFlg = false;
            this.addIndex = '';
        },
        cancelSaveHandle() {
            let subList = [];
            for (var i = 0; i < this.dataForm.subList.length; i++) {
                if (i != this.addIndex) {
                    subList.push(this.dataForm.subList[i]);
                }
            }
            this.dataForm.subList = subList;
            this.addFlg = false;
            this.addIndex = '';
        },
        updateHandle() {
            this.updateFlg = false;
            this.updateIndex = '';
        },
        cancelUpdateHandle() {
            for (var i = 0; i < this.dataForm.subList.length; i++) {
                if (i == this.updateIndex) {
                    this.dataForm.subList[i].colSort = this.updateData.colSort
                    this.dataForm.subList[i].subProgressName = this.updateData.subProgressName
                }
            }
            this.updateFlg = false;
            this.updateIndex = '';
        },
        addSubProgressHandle() {
            let subList = this.dataForm.subList;
            let maxSort = 1;
            if (subList != undefined && subList.length > 0) {
                for (var i = 0; i < subList.length; i++) {
                    if (maxSort < parseInt(subList[i].colSort)) {
                        maxSort = parseInt(subList[i].colSort);
                    }
                }
                maxSort = maxSort + 1;
            }
            let sub = {
                colName: '',
                progressNo: this.dataForm.progress,
                subProgressName: '',
                subProgressNo: '',
                colSort: maxSort,
            }
            this.dataForm.subList.push(sub);
            this.addFlg = true;
            this.addIndex = this.dataForm.subList.length - 1
        },
        deleteHandle(index) {
            this.dataForm.subList.splice(index, 1);
        },
        dataFormSubmit() {
            let _url = "/business/projectprogress/save";
            if (this.dataForm && this.dataForm.progressNo != '') {
                _url = "/business/projectprogress/update";
            }
            this.$http({
                url: this.$store.state.httpUrl + _url,
                method: "post",
                data: this.$http.adornData(this.dataForm)
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1500,
                        onClose: () => {
                            this.visible = false;
                            this.$emit("refreshDataList");
                        }
                    });
                }
            });
        }
    }
}
</script>
<style scoped>
.sp-input /deep/ .el-input__inner {
    width: 100% !important;
}

::v-deep .el-form-item {
    display: flex !important;
    align-items: stretch !important;
    margin-bottom: 0px !important;
}

.item::v-deep .el-form-item__label {
    color: #00428e !important;
    margin-right: 10px !important;
    font-weight: bold !important;
    background-color: rgb(211, 230, 248);
    white-space: nowrap !important;
    text-align: center !important;
}

.set_border {
    border: solid #dadada 1px;
    border-bottom: 0px solid #adadad;
}

.set_border1 {
    border: solid #dadada 1px;
}

.sp-input1 {
    margin-top: 2px;
    width: 240px !important;
}

.majTitle1 {
    background-color: #E1F1FF;
    padding-left: 35px;
    font-weight: bolder;
    color: #00428e !important;
    height: 45px;
    padding-top: 14px;
    border-right: solid #dadada 1px;
}

.majTitle2 {
    background-color: #E1F1FF;
    padding-left: 25px;
    font-weight: bolder;
    color: #00428e !important;
    height: 45px;
    padding-top: 12px;
}

.majTitle3 {
    padding-left: 15px;
    font-weight: bolder;
    color: #00428e !important;
    height: 45px;
    border-left: 0px;
}
</style>
